import $ from 'jquery'

export function ratingHistogram() {
  const $histogram = $('.review_rating');

  if ( SOPHIA.isIos() ) {
    $histogram.on('click', function(e) {
      e.preventDefault();

      if ($('.tooltip-list').is(':hidden')) {
        $('.tooltip-list').fadeIn();
      } else {
        $('.tooltip-list').fadeOut();
      }

      $(document).on('touchstart', function(e) {
        e.preventDefault();
        $('.tooltip-list').fadeOut();
        $(document).off('touchstart');
      });
    });
    $(window).on('resize', function() {
      $('.tooltip-list').fadeOut();
    });
  } else {
    // Rating histogram
    $histogram.on('mouseenter', function() {
      $('.tooltip-list').fadeIn();
    }).on('mouseleave', function() {
      $('.tooltip-list').fadeOut();
    });

    if ($histogram) {
      $histogram.on('focusin', function() {
        $('.tooltip-list').fadeIn();

        $histogram.on('focusout', function(){
          $('.tooltip-list').fadeOut();
        });
      });
    }
  }
}
